import axios from "axios";
import { useNuxtApp, useRequestHeaders, ref, useRuntimeConfig } from "#imports";
export const useOryValidateSession = async () => {
  const session = ref(null);
  const error = ref(null);
  const { $ory } = useNuxtApp();
  const { cookie } = useRequestHeaders(["cookie"]);
  const { nuxtOry } = useRuntimeConfig();
  try {
    if (nuxtOry?.custom) {
      const { data } = await axios.get(nuxtOry?.custom?.url, {
        headers: {
          Cookie: cookie
        }
      });
      session.value = nuxtOry?.custom?.transform ? nuxtOry?.custom?.transform(data) : data;
    } else {
      const { data } = await $ory.toSession(...process.server ? [{ cookie }] : []);
      session.value = data;
    }
  } catch (err) {
    error.value = err;
  }
  return {
    session,
    error
  };
};
